import settingsService from "../services/settings.service";
import { GET_AI_TOGGLE, GET_APPLE_LOGIN_TOGGLE, GET_SETTINGS, SET_FAILED_MESSAGE, SET_SUCCESS_MESSAGE, START_LOADER, STOP_LOADER } from "./types";

export const getSettingsAction = (payload) => async (dispatch) => {
  return settingsService.getSettings(payload).then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_SETTINGS, payload: resp.data, });
    }
  });
};


export const updateSettingsAction = (payload) => async (dispatch) => {
  dispatch({ type: START_LOADER });
  return settingsService.updateSettings(payload).then((resp) => {
    if (resp.status) {
      dispatch(getSettingsAction());
      dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.data,});
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
};

export const getAIToggleAction = () => async (dispatch) => {
  return settingsService.getAIToggle().then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_AI_TOGGLE, payload: resp.data });
    }
  });
};

export const updateAIToggleAction = (payload) => async (dispatch) => {
  dispatch({ type: START_LOADER });
  return settingsService.updateAIToggle(payload).then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_AI_TOGGLE, payload: resp.data });
      dispatch(getAIToggleAction());
      dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.message || resp.data });
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.message || resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
};

export const getAppleLoginToggleAction = () => async (dispatch) => {
  return settingsService.getAppleLoginToggle().then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_APPLE_LOGIN_TOGGLE, payload: resp.data });
    }
  });
};

export const updateAppleLoginToggleAction = (payload) => async (dispatch) => {
  dispatch({ type: START_LOADER });
  return settingsService.updateAppleLoginToggle(payload).then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_APPLE_LOGIN_TOGGLE, payload: resp.data });
      dispatch(getAppleLoginToggleAction());
      dispatch({ type: SET_SUCCESS_MESSAGE, payload: resp.message || resp.data });
    } else {
      dispatch({ type: SET_FAILED_MESSAGE, payload: resp.message || resp.data });
    }
    dispatch({ type: STOP_LOADER });
  });
};
